module.exports = __webpack_public_path__ + "img/name_white.a356b32c.png";